export default __webpack_public_path__ + "static/description-field-69e783ef03740b1ff0bad1639d51fff6.jpg";